// Service Worker Registration for PWA
import { Capacitor } from '@capacitor/core';

// Store the waiting service worker for later activation
let waitingServiceWorker = null;

export function registerServiceWorker() {
  // Guard : ne PAS enregistrer le Service Worker dans les WebViews natifs Capacitor
  // (iOS/Android). Le SW intercepte les requêtes du bundle local et provoque des
  // écrans noirs / rendus bloqués dans WKWebView / Android WebView.
  // Recommandation officielle Capacitor 2025.
  if (Capacitor && typeof Capacitor.isNativePlatform === 'function' && Capacitor.isNativePlatform()) {
    console.log('[SW] Skipped in native Capacitor WebView');
    return;
  }
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then((registration) => {
          console.log('SW registered: ', registration.scope);
          
          // Check for updates every 5 minutes
          setInterval(() => {
            registration.update();
          }, 5 * 60 * 1000);
          
          // Check for updates on page focus
          document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
              registration.update();
            }
          });
          
          // Check for updates
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New update available
                console.log('New content available!');
                waitingServiceWorker = newWorker;
                
                // Dispatch custom event to notify React components
                window.dispatchEvent(new CustomEvent('sw-update-available'));
              }
            });
          });
          
          // Listen for user's decision to update
          window.addEventListener('sw-do-update', () => {
            if (waitingServiceWorker) {
              waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
          
          // Fix 2026-09-20 (Android/OPPO écran noir) — Le reload automatique sur
          // `controllerchange` provoquait un flash d'écran noir 200-500ms sur PWA Android
          // (WebView Chrome / ColorOS) à chaque activation silencieuse d'un nouveau SW.
          // On rend le reload OPT-IN : il ne se déclenche QUE si l'utilisateur a cliqué
          // "Mettre à jour" dans le banner UpdateNotification (event `sw-do-update`).
          // Sinon, le nouveau SW prend le contrôle silencieusement — la nouvelle version
          // sera utilisée dès la prochaine navigation/reload naturel.
          let userAcceptedUpdate = false;
          window.addEventListener('sw-do-update', () => {
            userAcceptedUpdate = true;
          });
          navigator.serviceWorker.addEventListener('controllerchange', () => {
            if (userAcceptedUpdate) {
              window.location.reload();
            }
          });
        })
        .catch((error) => {
          console.log('SW registration failed: ', error);
        });
    });
  }
}

export function unregisterServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}

// Check if app is installed as PWA
export function isPWAInstalled() {
  return window.matchMedia('(display-mode: standalone)').matches ||
         window.navigator.standalone === true;
}

// Prompt to install PWA
let deferredPrompt = null;

export function initInstallPrompt() {
  window.addEventListener('beforeinstallprompt', (e) => {
    // Prevent the mini-infobar from appearing
    e.preventDefault();
    // Save the event for later
    deferredPrompt = e;
    console.log('Install prompt ready');
  });

  window.addEventListener('appinstalled', () => {
    console.log('PWA was installed');
    deferredPrompt = null;
  });
}

export function canInstallPWA() {
  return deferredPrompt !== null;
}

export async function installPWA() {
  if (!deferredPrompt) {
    return false;
  }
  
  // Show the install prompt
  deferredPrompt.prompt();
  
  // Wait for the user's response
  const { outcome } = await deferredPrompt.userChoice;
  console.log(`User response to install prompt: ${outcome}`);
  
  // Clear the deferred prompt
  deferredPrompt = null;
  
  return outcome === 'accepted';
}
